import { get } from 'utils/fetch';
import { apiAccountPath } from 'routing/routes';

export const getAccount = () => get(apiAccountPath);
